export const shadowDialog = '0px 4px 2px rgba(16, 16, 16, 0.2)';
export const shadowToast = '0px 2px 12px rgba(16, 16, 16, 0.12)';
export const shadowDropdown = '0px 2px 12px rgba(16, 16, 16, 0.12)';
export const shadowButton = '0px 2px 4px rgba(16, 16, 16, 0.2)';
export const shadowCard = '0px 2px 8px rgba(16, 16, 16, 0.12)';
export const shadowFAB = '0px 2px 8px rgba(16, 16, 16, 0.12)';
